<template>

  <div class="page">

    <!--Title/Actions-->
    <div class="page-header flex-shrink-0 mb-3 bg-white border-bottom">
      <div class="container-fluid d-flex justify-content-between align-items-center px-md-4 px-3">
        <h3 class="mb-0"><i class="fas fa-building"></i>&nbsp;Properties</h3>
        <b-form inline>
          <b-form-checkbox class="mr-3 d-md-block d-none" v-model="showArchived" switch @input="toggleShowArchived"><span>Show
              Archived</span></b-form-checkbox>
          <router-link title="New Property" :to="{ name: 'Property', params: { id: 'new' }}">
            <b-btn class="btn btn-success">
              <i class="fas fa-plus"></i> Property
            </b-btn>
          </router-link>
        </b-form>
      </div>
    </div>

    <!--Search-->
    <div class="container-fluid px-md-4 px-3 py-3 bg-white border-bottom mb-3">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-6">
          <b-input-group>
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
          </b-input-group>
        </div>
        <b-button :disabled="!filter" variant="link" @click="filter = ''">Clear</b-button>
      </div>
    </div>

    <!--Table-->
    <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3">
      <div v-if="properties">
        <b-table id="properties-table" bordered class="mb-5 rg-table" :items="propertyProvider"
          :fields="propertyTableData.fields" no-local-filtering :filter="filter" no-local-sorting
          :sortDesc.sync="sortDesc" :busy.sync="isBusy">
          <template v-slot:cell(number)="data">
            <div class="emphasis">
              {{ data.item.number }}
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <div class="emphasis">
              {{ data.item.name }}
            </div>
          </template>
          <template v-slot:cell(address)="data">
            <div>
              {{ data.item.address.city }}, {{ data.item.address.state }}
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <router-link title="Edit Property" :to="{ name: 'Property', params: { id: data.item.id }}"
              class="btn btn-link"><i class="fas fa-edit"></i></router-link>
          </template>
          <template v-slot:cell(isArchived)="data">
            <b-icon-archive v-if="data.item.isArchived" />
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../mixins/Spr2SharedFunctions'
export default {
  name: 'Properties',
  created () {
    this.fields = [
      {key: 'number', label: 'Number', sortable: true},
      {key: 'name', label: 'Name', sortable: true},
      {key: 'address', label: 'Address', sortable: true},
      {key: 'numberOfUnits', label: '# Units', sortable: true},
      {key: 'isArchived', label: 'Archived', sortable: true},
      {key: 'id', label: 'Actions'}]
  },
  mixins: [spr2Validation],
  components: {
  },
  data () {
    return {
      fields: [],
      properties: [],
      isBusy: false,
      showArchived: false,
      sortBy: null,
      sortDirection: 'asc',
      filter: null,
      sortDesc: true
    }
  },
  computed: {
    propertyTableData () {
      var returnProperties = {
        fields: this.fields.filter(f => {
          return this.showArchived ? true : f.key !== 'isArchived'
        })
      }
      console.log(
        'Event Table Data is: ' +
          JSON.stringify(returnProperties, null, 2)
      )
      return returnProperties
    }
  },
  methods: {
    ...mapActions('company', ['getProperties']),
    propertyProvider (ctx) {
      this.isBusy = true
      console.log(
        'property table ctx is: ' +
          JSON.stringify(ctx, null, 2)
      )
      var request = { sortBy: ctx.sortBy, sortDirection: ctx.sortDesc ? 'desc' : 'asc', showArchived: this.showArchived, search: ctx.filter }

      // Must return a promise that resolves to an array of items
      return this.getProperties(request).then(r => {
        // Pluck the array of items off our axios response
        const items = r.data.properties
        console.log(
          'Returned Table Data is: ' +
          JSON.stringify(items, null, 2)
        )
        this.isBusy = false
        // Must return an array of items or an empty array if an error occurred
        return items || []
      })
    },
    toggleShowArchived (value) {
      this.$root.$emit('bv::refresh::table', 'properties-table')
    }
  }
}
</script>

<style>
.ui.modals.active .modal {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Properties.vue